import React, { useState, useEffect, useRef } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import {
  Form,
  Button,
  GridRow,
  Input,
  Icon,
  Message,
  Modal,
  FormGroup,
} from "semantic-ui-react";
import { useContext } from "react";
import { AppContext } from "../../../Context/AppContext";
import ADD_UNIT from "./cmp-add-unit/cmp-add-unit";
import "./OrderRequestForm.css";
import {
  portalReadPdf,
  treatmentPrice,
  getSingleBuilding,
} from "../../../constants";
import MDL_PROGRESS from "../../../components/cmp-progress/cmp-progress";
import { useToasts } from "react-toast-notifications";

function OrderRequestForm() {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const {
    bInfo,
    selected_units,
    building_order_details,
    error_validation,
    userInfo,
    cartItems,
    UncheckedUnitsData,
    checkedUnitsData,
    orderPriceSummary,
    ShowHeaderSearch,
    buildingUnits,
    sbuildingData,
    defaultPane,
    error_message,
    impersonator,
    appVersion,
    isAppVersionOutdated,
    // selectedBuilding,
  } = useContext(AppContext);
  const [user] = userInfo;
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [building_units, setBuildingUnits] = buildingUnits;
  const [single_building_data, setSingleBuildingData] = sbuildingData;
  const [selected_building, setSelectedBuilding] = useState({});
  const [pestTreated, setPestTreated] = useState();
  const [form_validation_error, setFormError] = error_validation;
  const [treatmentOption, setTreatmentOptions] = useState();
  const [error, setError] = useState(false);
  const [var_add_unit, set_add_unit] = selected_units;
  const [building_info, setBuildingInfo] = bInfo;
  const [building_order, setBuildingOrder] = building_order_details;
  const [var_ShowHeaderSearch, setShowHeaderSearch] = ShowHeaderSearch;
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [var_first_loading, set_first_loading] = useState(true);
  const history = useHistory();
  const [cart_items, setCartItems] = cartItems;
  const [UncheckedUnits, setUnCheckedUnits] = UncheckedUnitsData;
  const [checkedUnits, setCheckedUnits] = checkedUnitsData;
  const { locationID } = useParams();
  const location = useLocation();
  const [selectFile, setSelectFile] = useState(null);
  const [suitPostData, setSuitPostData] = useState(null);
  const [filteredArray, setfilteredArray] = useState([]);
  const { addToast } = useToasts();
  const [orderSummary, setorderSummary] = orderPriceSummary;
  const prevVarAddUnitRef = useRef([]);
  const [, set_default_pane] = defaultPane;
  const [errorMessage] = error_message;
  const [impersonatorID] = impersonator;
  const isImpersonating = localStorage.getItem("impersonation") === "true";

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {
    if (var_add_unit.length) {
      // Check if the array contains only one element with treatment as null
      if (var_add_unit.length === 1 && var_add_unit[0].treatment === null) {
        setorderSummary([]);
      } else {
        // Filter items that have a treatment before summing up
        const filteredUnits = var_add_unit.filter(
          (order) => order.treatment !== undefined && order.treatment !== null,
        );
        setfilteredArray(filteredUnits);
        const totalSum = filteredUnits.reduce(
          (acc, order) => acc + order.price,
          0,
        );

        const tax = single_building_data?.tax / 100;
        const totalWithTax = totalSum + totalSum * tax;

        if (!isNaN(totalWithTax)) {
          setorderSummary([
            {
              total: totalWithTax,
              subtotal: totalSum,
              taxPrice: totalSum * tax,
            },
          ]);
        }
        if (filteredArray.length > 0) {
          set_mdl_progress(false);
        }
      }
    }
  }, [var_add_unit]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("order-list") === "true") {
      set_default_pane(1); // If order-list=true, open the second tab
    } else {
      set_default_pane(0); // Otherwise, open the first tab
    }
  }, [location.search, set_default_pane]);

  useEffect(() => {
    // Find new or updated entries
    const newOrUpdatedEntries = var_add_unit.filter(
      (currentItem) => currentItem.fetch_price === true,
    );

    // Fetch prices for each new or updated entry
    newOrUpdatedEntries.forEach((entry) => {
      if (entry.treatment) {
        fetchTreatmentPrice(entry);
      }
    });

    // Update the previous state reference
    prevVarAddUnitRef.current = var_add_unit;
  }, [var_add_unit, selected_building]);

  useEffect(() => {
    if (building_info && building_info.length) {
      const sBData = building_info.filter((b) => b.location_id == locationID);
      setSelectedBuilding(sBData?.length && sBData[0]);
      var temp_b_order = { ...building_order };
      temp_b_order = {
        ...temp_b_order,
        building_name: (sBData && sBData[0]?.text) || "",
      };
      setBuildingOrder(temp_b_order);
    } else {
      history.goBack();
    }
  }, [building_info]);

  useEffect(() => {
    if (building_units.length === 0 || var_first_loading) {
      getBuildingUnits();
    }
  }, [building_units, selected_building, var_first_loading]);

  useEffect(() => {
    if (UncheckedUnits && UncheckedUnits !== "All") {
      // Create a copy of checkedUnits object
      const updatedCheckedUnits = { ...checkedUnits };
      // Extract floor and unit from UncheckedUnits
      const [floor, unit] = UncheckedUnits.split("-");
      // Construct the key for the unit
      const unitKey = `${floor}-${unit}`;
      // Delete the unit from the object
      delete updatedCheckedUnits[unitKey];
      // Set the updated object to state
      //getBuildingHeatmap()
      setCheckedUnits(updatedCheckedUnits);
      setUnCheckedUnits(null);
    } else if (UncheckedUnits == "All") {
      setCheckedUnits({});
      setUnCheckedUnits(null);
    }
  }, [UncheckedUnits, checkedUnits]);

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/
  const fetchTreatmentPrice = async (entry) => {
    if (selected_building.value) {
      set_mdl_progress(true);
      const requestHeaders = {
        headers: {
          entityid: isImpersonating ? impersonatorID : selected_building?.value,
          appversion: var_app_version,
        },
      };
      try {
        const tax = 0.13;
        const response = await fetch(
          treatmentPrice +
            "?building_uuid=" +
            selected_building.value +
            "&unit_number=" +
            entry.unit_number +
            "&pest=" +
            entry.pest +
            "&treatment=" +
            entry.treatment +
            "&pestID=" +
            entry.pest_id +
            "&treatmentID=" +
            entry.treatment_id,
          requestHeaders,
        );
        const result = await response.json();
        if (result.code !== 200) {
          if (result?.version && result?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        // Assuming result contains { price: <price> }
        if (result?.data?.price !== undefined) {
          const priceWithTax = result.data.price * tax;
          // Update only the specific object with the returned price
          set_add_unit((prevState) =>
            prevState.map((item) =>
              item.key === entry.key
                ? {
                    ...item,
                    price: result.data.price,
                    fetch_price: false,
                    price_tax: priceWithTax,
                  }
                : item,
            ),
          );
        } else {
          set_add_unit((prevState) =>
            prevState.map((item) =>
              item.key === entry.key
                ? { ...item, price: 0, fetch_price: false, price_tax: 0 }
                : item,
            ),
          );
        }
      } catch (error) {
        console.error("Error fetching treatment price:", error);
      }
    }
  };

  const onChangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "po_mo_wo") {
      value = value.replace(/^\s+/g, "");
    }
    setBuildingOrder({ ...building_order, [name]: value });
  };

  async function getBuildingUnits(selected_id) {
    const requestHeaders = {
      headers: {
        entityid: isImpersonating ? impersonatorID : selected_building?.value,
        appversion: var_app_version,
      },
    };
    if (selected_id) {
      await fetch(`${getSingleBuilding}${selected_id}`, requestHeaders)
        .then((response) => response.json())
        .then((response) => {
          if (response.code !== 200) {
            if (response?.version && response?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }
          const final_data = response.data[0];
          setSingleBuildingData(final_data);
          setBuildingUnits(final_data?.units ? final_data?.units : []);
        });
    } else if (selected_building?.value) {
      await fetch(
        `${getSingleBuilding}${selected_building?.value}`,
        requestHeaders,
      )
        .then((response) => response.json())
        .then((response) => {
          if (response.code !== 200) {
            if (response?.version && response?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }
          const final_data = response.data[0];
          setSingleBuildingData(final_data);
          setBuildingUnits(final_data?.units ? final_data?.units : []);
        });
    }
    set_first_loading(false);
  }

  const add_unit = () => {
    setFormError([...form_validation_error, {}]);
    set_add_unit([
      ...var_add_unit,
      { unit_number: "", followup: "neworder", key: var_add_unit.length },
    ]);
  };

  function pushRoute(isDraft = false) {
    var isValid = true;
    if (single_building_data?.building_po_mo_wo) {
      if (!building_order?.po_mo_wo) {
        isValid = false;
      }
    } else {
      isValid = true;
    }
    var_add_unit.map((value, i) => {
      if (
        form_validation_error[i]?.unit_number ||
        !value.unit_number ||
        !value.pest_id ||
        !value.treatment_id ||
        !value.followup ||
        ((value.pest === "Unknown" || value.pest === "Other Pest") &&
          !value.order_description?.trim())
      ) {
        isValid = false;
        addToast("Please fill all required(*) fields .", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    });
    if (errorMessage.some((msg) => msg && msg.trim() !== "")) {
      isValid = false;
    }

    if (calculateNotesLength(var_add_unit) > 7000) {
      addToast(
        "Limit exceeded: Please reduce Notes length to 7000 characters.",
        {
          appearance: "error",
          autoDismiss: true,
        },
      );
      return;
    }

    if (isValid) {
      ///technician-home/order-review
      if (user.role === "technician") {
        history.push("/technician-home/order-review");
      } else {
        history.push("/order-review", { isDraft });
      }
    } else {
      isValid = true;
      setError(true);
    }
  }

  const handleDeleteItem = async (itemKey, index, unit_number) => {
    // Make a copy of cart_items
    const updatedCartItems = { ...cart_items };

    // Find the item by unit_number and remove it
    const itemIndex = updatedCartItems[itemKey].findIndex(
      (item) => item.unit_number === unit_number,
    );

    if (itemIndex !== -1) {
      updatedCartItems[itemKey].splice(itemIndex, 1);
    }

    // If the array becomes empty after deletion, remove it from cart_items
    if (updatedCartItems[itemKey].length === 0) {
      delete updatedCartItems[itemKey];
    }

    // Set unCheckedUnits after the item has been removed
    const DeleteUnitData = itemKey + "-" + unit_number;
    setUnCheckedUnits(DeleteUnitData);

    // Check if updatedCartItems is empty
    if (Object.keys(updatedCartItems).length === 0) {
      // Handle the case when cart_items becomes empty
      setCartItems(null);
    } else {
      // Update the state with the new cart_items
      setCartItems({ ...updatedCartItems });
    }
  };

  const doDelete = (index) => {
    var items = [...var_add_unit];
    if (items[index].floor) {
      handleDeleteItem(items[index].floor, index, items[index]?.unit_number);
    }
    items.splice(index, 1);
    items.map((val, index) => {
      var temp = val;
      temp.key = index;
      items[index] = temp;
    });

    set_add_unit(items);
  };

  const onChangeFile = async (event) => {
    const file = event.target.files[0];
    if (file) {
      set_mdl_progress(true);
      let data = new FormData();
      data.append("document", file);
      data.append("buildingAddress", selected_building?.text);
      fetch(portalReadPdf, {
        method: "POST",
        body: data,
        headers: {
          entityid: isImpersonating ? impersonatorID : selected_building?.value,
          appversion: var_app_version,
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.code !== 200) {
            if (response?.version && response?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }

          set_mdl_progress(false);
          if (response.code == 200 && response.data) {
            let { buildingAddress, unitNumber, poNumber } = response.data;

            if (
              buildingAddress.includes(selected_building?.text) ||
              selected_building?.text.includes(buildingAddress)
            ) {
              setBuildingOrder({
                ...building_order,
                po_mo_wo: poNumber.replace(/^\s+/g, ""),
              });

              var temp = [...var_add_unit];
              temp[0] = { ...temp[0], unit_number: unitNumber };
              set_add_unit(temp);
              setSuitPostData(response.data);
            } else {
              addToast("This document is not related to selected building.", {
                appearance: "error",
                autoDismiss: true,
              });
            }
          } else {
            addToast(response?.message, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        })
        .catch((error) => {
          set_mdl_progress(false);
          console.log("Error:::", error);
        });
    }
  };

  const calculateNotesLength = (items) => {
    return items.reduce((total, item) => {
      return (
        total + (item.order_description ? item.order_description.length : 0)
      );
    }, 0);
  };

  /* RENDER APP
	---------------------------------------------------------------------------------*/

  return (
    <div className="app-content">
      <div className="order-request-form-container">
        <div className="app-backto-prev-page">
          <div
            className="app-goback-button"
            onClick={() => {
              setFormError([{}]);
              //setBuildingOrder({});
              set_add_unit([{ unit_number: "", followup: false, key: 0 }]);
              setShowHeaderSearch(!var_ShowHeaderSearch);
              setorderSummary([]);
              history.push("/home");
            }}
          >
            <Icon name="arrow left" /> Go Back
          </div>
        </div>
        <div className="order-card-row">
          <div className="order-details-container">
            <div className="order-app-card">
              <Form error={error}>
                <div className="app-card">
                  <div className="app-card-header">
                    <div className="app-card-title">Service Request</div>
                  </div>
                  <div className="app-card-body">
                    <Form.Group>
                      <Form.Field
                        label="Location"
                        width={8}
                        control={Input}
                        required
                        value={selected_building?.text}
                      />
                      {selectFile && (
                        <Form.Field
                          id="upload_file"
                          name="upload_file"
                          label="Please upload PO/MO"
                          control={Input}
                          width={8}
                          type="file"
                          onChange={onChangeFile}
                        />
                      )}
                      {
                        //    selected_building && selected_building.building_po_mo_wo?
                        <Form.Field
                          disabled={selectFile}
                          label={
                            single_building_data?.building_po_mo_wo?.toLowerCase() ===
                            "wo"
                              ? "Work Order Number"
                              : single_building_data?.building_po_mo_wo?.toLowerCase() ===
                                  "mo"
                                ? "Maintenance Order Number"
                                : "Purchase Order Number"
                          }
                          width={8}
                          control={Input}
                          required={single_building_data?.building_po_mo_wo}
                          name="po_mo_wo"
                          id="po_mo_wo"
                          value={building_order?.po_mo_wo}
                          placeholder={`${
                            single_building_data?.building_po_mo_wo?.toUpperCase() ||
                            "PO "
                          } number must be entered here before submitting request`}
                          onChange={onChangeInput}
                          maxLength={30}
                        />
                        // :null
                      }
                    </Form.Group>
                  </div>
                </div>
                <div className="add-unit-container">
                  {var_add_unit?.map((unit, index) => (
                    <ADD_UNIT
                      key={index}
                      index={index}
                      width={8}
                      treatment={treatmentOption}
                      pest={pestTreated}
                      editable_unit={selectFile}
                      doDelete={doDelete.bind(this, index)}
                      isTech={user.role === "technician"}
                      pdfData={suitPostData}
                      buildingID={locationID}
                    />
                  ))}
                </div>
                <Message
                  error
                  header="Required Fields"
                  content="Please fill all required(*) fileds"
                />
                <div className="finish-request-actions">
                  {!selectFile && (
                    <>
                      <Button
                        className="add-unit-button"
                        color="grey"
                        type="button"
                        onClick={() => add_unit()}
                      >
                        <img src="/add-square.svg" alt="" />
                        Add Unit
                      </Button>
                    </>
                  )}
                </div>
              </Form>
            </div>
          </div>
          <div className="order-summary-container">
            <div className="order-app-card">
              {/* <div className="app-card-header">
                <div className="app-card-title"></div>
                </div> */}
              <div className="app-card-body">
                {orderSummary.length > 0 && filteredArray.length > 0 && (
                  <>
                    <div className="order-list-header">
                      <div className="list-header-one">Order Summary</div>
                      <div className="list-header-two">Price</div>
                    </div>
                    <span
                      style={{
                        borderTop: "1px solid",
                        width: "100%",
                        display: "block",
                        marginBottom: "10px",
                      }}
                    ></span>
                  </>
                )}

                <div className="order-list-items">
                  {var_add_unit &&
                    var_add_unit.map((item, index) => (
                      <>
                        {item?.treatment && (
                          <div className="order-list-item" key={index}>
                            <span className="order-title">
                              {item.unit_number} - {item.pest} -{" "}
                              {item.treatment}
                            </span>
                            <span className="order-price">${item.price}</span>
                          </div>
                        )}
                      </>
                    ))}
                  {orderSummary.length > 0 && filteredArray.length > 0 && (
                    <>
                      <span
                        style={{
                          borderTop: "1px solid",
                          width: "100%",
                          display: "block",
                          marginBottom: "10px",
                        }}
                      ></span>
                      <div className="total-area">
                        <div className="total-area-one"></div>
                        <div className="total-area-two">
                          <div className="order-tax">
                            <span style={{ fontWeight: "bold" }}>
                              SUBTOTAL :{" "}
                            </span>{" "}
                            <span style={{ float: "right" }}>
                              ${orderSummary[0]?.subtotal?.toFixed(2)}
                            </span>
                          </div>
                          <div className="order-tax">
                            <span style={{ fontWeight: "bold" }}>TAX : </span>{" "}
                            <span style={{ float: "right" }}>
                              ${orderSummary[0]?.taxPrice?.toFixed(2)}
                            </span>
                          </div>
                          <div className="order-tax">
                            <span style={{ fontWeight: "bold" }}>TOTAL : </span>{" "}
                            <span style={{ float: "right" }}>
                              ${orderSummary[0]?.total?.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {filteredArray.length === 0 && (
                    <>
                      <GridRow
                        columns={5}
                        style={{
                          maxHeight: "730px",
                          overflowY: "auto",
                          height: "50%",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "16px",
                            backgroundColor: "white",
                            color: "#000000",
                            fontWeight: 700,
                            textAlign: "center",
                          }}
                        >
                          <img src="/no-data.png" alt="icon" />
                        </div>
                      </GridRow>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="finish-request-actions">
              {!selectFile && (
                <>
                  <Button color="orange" onClick={() => pushRoute(true)}>
                    Save as draft
                  </Button>
                </>
              )}
              <Button color="red" onClick={() => pushRoute()}>
                Finish Request
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/***** MODAL: PROGRESS **************************************************************************/}
      <Modal
        id="mdl-progress"
        dimmer={"inverted"}
        open={var_mdl_progress}
        closeOnDimmerClick={false}
        closeOnEscape={false}
        onClose={() => {}}
      >
        <MDL_PROGRESS
          set_mdl_open={set_mdl_progress}
          var_modaltitle="Please wait"
          var_message={"Please wait..."}
        ></MDL_PROGRESS>
      </Modal>

      {/***** END MODAL: PROGRESS **************************************************************************/}
    </div>
  );
}

export default OrderRequestForm;
